// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.bg-soft-primary {
    background-color: rgba(102,88,221,.25);
}

.avatar-lg {
    height: 4.5rem;
    width: 4.5rem;
}

.rounded-circle {
    border-radius: 50%!important;
}

.border-primary {
    border: 1px solid #6658dd!important;
}

/* .border {
    border: 1px solid #6658dd!important;
} */

.text-primary {
    color: #6658dd!important;
}


.avatar-title {
    align-items: center;
    color: #fff;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.font-22 {
    font-size: 22px!important;
}

.bg-soft-success {
    background-color: rgba(26,188,156,.25);
}

.border-success {
    border: 1px solid #1abc9c!important;
}

.text-success {
    color: #1abc9c!important;
}

.text-info {
    color: #4fc6e1!important;
}

.bg-soft-info {
    background-color: rgba(79,198,225,.25);
}

.border-info {
    border: 1px solid #4fc6e1!important;
}

.text-warning {
    color: #f7b84b!important;
}

.border-warning {
    border: 1px solid #f7b84b!important;
}

.bg-soft-warning {
    background-color: rgba(247,184,75,.25);
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/component/kpis/nemt-report/nemt-report.component.css"],"names":[],"mappings":"AAAA;IACI,mFAAmF;AACvF;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;AAC5B;;;AAGA;IAEI,mBAAmB;IACnB,WAAW;IAEX,aAAa;IACb,YAAY;IAEZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;AAC1C;AAFA,glFAAglF","sourcesContent":[".card {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.bg-soft-primary {\n    background-color: rgba(102,88,221,.25);\n}\n\n.avatar-lg {\n    height: 4.5rem;\n    width: 4.5rem;\n}\n\n.rounded-circle {\n    border-radius: 50%!important;\n}\n\n.border-primary {\n    border: 1px solid #6658dd!important;\n}\n\n/* .border {\n    border: 1px solid #6658dd!important;\n} */\n\n.text-primary {\n    color: #6658dd!important;\n}\n\n\n.avatar-title {\n    -webkit-box-align: center;\n    align-items: center;\n    color: #fff;\n    display: -webkit-box;\n    display: flex;\n    height: 100%;\n    -webkit-box-pack: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.font-22 {\n    font-size: 22px!important;\n}\n\n.bg-soft-success {\n    background-color: rgba(26,188,156,.25);\n}\n\n.border-success {\n    border: 1px solid #1abc9c!important;\n}\n\n.text-success {\n    color: #1abc9c!important;\n}\n\n.text-info {\n    color: #4fc6e1!important;\n}\n\n.bg-soft-info {\n    background-color: rgba(79,198,225,.25);\n}\n\n.border-info {\n    border: 1px solid #4fc6e1!important;\n}\n\n.text-warning {\n    color: #f7b84b!important;\n}\n\n.border-warning {\n    border: 1px solid #f7b84b!important;\n}\n\n.bg-soft-warning {\n    background-color: rgba(247,184,75,.25);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
